import { UserData } from "@/entities/users/types";
import { useTranslation } from "react-i18next";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger
} from "@/components/ui/tooltip";
import { InfoCircle } from "@dreamhub/designsystem/icons";
import IconContainer from "@/components/ui/icon-container";
import UserAvatar from "@/components/controls/UserAvatar";
import Text from "@/components/ui/text";
import { GradientCardContainer } from "./GradientCardContainer";

interface TokenHolderCardProps {
  tokenHolder: UserData;
  nextSteps: string;
}
export const TokenHolderCard: React.FC<TokenHolderCardProps> = ({
  tokenHolder,
  nextSteps
}) => {
  const { t } = useTranslation();

  return (
    <GradientCardContainer className="gap-0 rounded-xl">
      <div className="flex p-1 items-center justify-between w-full">
        <Text variant="bodySecondary" className="text-h2">
          {t("leads.nextSteps.tokenHolder.title")}
        </Text>
        <Tooltip>
          <TooltipTrigger asChild>
            <IconContainer color="tertiary" nativeStroke>
              <InfoCircle />
            </IconContainer>
          </TooltipTrigger>
          <TooltipContent maxWidth={18}>
            {t("leads.nextSteps.tokenHolder.infoTooltip")}
          </TooltipContent>
        </Tooltip>
      </div>
      <div className="flex flex-col gap-2 p-2">
        <div className="flex gap-2 items-center">
          <UserAvatar
            userData={tokenHolder}
            fallbackClassName="bg-gradient-to-t from-slate-600 to-tertiary"
          />
          <Text variant="label">{tokenHolder?.displayName}</Text>
          <Text variant="bodySecondary">{tokenHolder?.jobTitle}</Text>
        </div>
        <Text variant="bodySecondary" className="pl-9">
          {nextSteps}
        </Text>
      </div>
    </GradientCardContainer>
  );
};
